/**
 * The public routes zennopay.com serves that this repo does not own.
 *
 * `evaluatePublishGate` refuses a body that links to a page the site does not
 * serve, so it has to be told what the site serves. Guide routes are derived
 * from the CMS; everything else is generated by the landing repo, which neither
 * the publish function nor the browser can see, so the list is checked in.
 *
 * THIS IS THE CANONICAL COPY, and it lives here for one reason: the gate has two
 * callers. `packages/cms` runs it to show the editor a panel, and
 * `functions/src/publish.ts` runs it to actually block. Those two ran off
 * separate hand-maintained arrays, and a drift between them meant the panel and
 * the enforcing function disagreed about `link.broken` -- the panel goes green,
 * the publish is refused, and the editor has nothing on screen explaining why.
 * That is precisely the failure the shared-gate design exists to prevent, so the
 * list belongs in the package both callers already depend on.
 *
 * Being stale is still possible, and it is the safe direction to be wrong in: a
 * route deleted from the landing repo and left here means a broken link ships,
 * which the gate would have caught, whereas a route added there and missing here
 * only blocks an editor on a link that actually works. The second is annoying;
 * the first is the failure this rule exists to prevent, so regenerate the list
 * whenever the landing repo adds or removes a page.
 *
 * Regenerated from the landing repo's build output:
 *   find dist -name '*.html' | sed 's|^dist||;s|/index\.html$|/|'
 */
export const STATIC_SITE_ROUTES = [
    '/',
    '/about/',
    '/aml-policy.html',
    '/compliance/',
    '/coverage/',
    '/coverage/afghanistan/',
    '/coverage/armenia/',
    '/coverage/azerbaijan/',
    '/coverage/bahrain/',
    '/coverage/bangladesh/',
    '/coverage/bhutan/',
    '/coverage/brunei/',
    '/coverage/cambodia/',
    '/coverage/china/',
    '/coverage/cyprus/',
    '/coverage/georgia/',
    '/coverage/hong-kong/',
    '/coverage/india/',
    '/coverage/indonesia/',
    '/coverage/iraq/',
    '/coverage/israel/',
    '/coverage/japan/',
    '/coverage/jordan/',
    '/coverage/kazakhstan/',
    '/coverage/kuwait/',
    '/coverage/kyrgyzstan/',
    '/coverage/laos/',
    '/coverage/lebanon/',
    '/coverage/macao-sar/',
    '/coverage/malaysia/',
    '/coverage/maldives/',
    '/coverage/mongolia/',
    '/coverage/myanmar/',
    '/coverage/nepal/',
    '/coverage/oman/',
    '/coverage/pakistan/',
    '/coverage/palestine/',
    '/coverage/philippines/',
    '/coverage/qatar/',
    '/coverage/saudi-arabia/',
    '/coverage/singapore/',
    '/coverage/south-korea/',
    '/coverage/sri-lanka/',
    '/coverage/taiwan/',
    '/coverage/tajikistan/',
    '/coverage/thailand/',
    '/coverage/timor-leste/',
    '/coverage/turkiye/',
    '/coverage/turkmenistan/',
    '/coverage/united-arab-emirates/',
    '/coverage/uzbekistan/',
    '/coverage/vietnam/',
    '/guides/',
    '/industries/banks/',
    '/industries/fx/',
    '/industries/travel/',
    '/industries/wallets/',
    '/privacy-policy.html',
    '/terms-and-conditions.html',
    '/use-cases/global-businesses/',
];
